export const MAX_SIZE_PAYLOAD = 4718592 // 4.5 MB (4.5 * 1024 * 1024)
export const TIME_ONE_WEEK = 60 * 60 * 24 * 7
export const MAX_PAYMENT_DESTINATIONS = 2
export const DIALOG_MEDIUM_WIDTH = 600
export const MAX_ATTACHMENTS = 2

export const SANDBOX_BANNER_HEIGHT = 35

export const DEFAULT_ACCEPTED_FILES = {
    'image/jpeg': [],
    'image/png': [],
    'application/pdf': []
}

export const INVOICE_AND_RECEIVABLE_ACCEPTED_FILE_TYPES = {
    ...DEFAULT_ACCEPTED_FILES,
    'application/json': [],
    'text/csv': []
}

export const DEFAULT_PAGE_SIZE = 20

export const GODMODE_TOKEN = 'godmode_token'
export const K2_ORIGIN = 'k2_origin'
